// ** React Import
import { useState, useEffect } from 'react';

// ** Custom Components
import Sidebar from '@components/sidebar';
import CustomTable from '@myComponents/CustomTable';

// ** GraphQL
import { FIND_USERAUDIO_HISTORY } from '../../graphql/Query/roadshistory';
import { useQuery } from '@apollo/client';

// ** Third Party Components
import moment from 'moment';

// ** Reactstrap Imports
import { Label } from 'reactstrap';

const userColumns = [
    {
        name: 'USUARIO',
        minWidth: '200px',
        selector: (row) => row.user?.fullName,
        cell: (row) => (
            <div className="d-flex flex-column">
                <span className="fw-bolder">{row.user?.fullName || 'No completado'}</span>
                <small className="text-muted">{row.user?.email}</small>
            </div>
        )
    },
    {
        name: 'FECHA',
        minWidth: '150px',
        selector: (row) => row.createdAt,
        cell: (row) => (
            <span>{moment(row.createdAt).format('DD/MM/YYYY HH:mm')}</span>
        )
    }
];

const AudioHistorySidebar = ({ open, toggleSidebar, selectedAudio }) => {
    const [variables, setVariables] = useState({
        search: {
            q: '',
            page: 1,
            perPage: 10,
            audio: null,
            episode: null
        }
    });

    // Update variables when selectedAudio changes
    useEffect(() => {
        if (selectedAudio?._id) {
            setVariables({
                search: {
                    q: '',
                    page: 1,
                    perPage: 10,
                    audio: selectedAudio.audio,
                    episode: selectedAudio._id
                }
            });
        }
    }, [selectedAudio]);

    const { data, refetch, loading } = useQuery(FIND_USERAUDIO_HISTORY, {
        variables,
        skip: !selectedAudio?._id
    });

    const handleSidebarClosed = () => {
        // Reset variables when sidebar closes
        setVariables({
            search: {
                q: '',
                page: 1,
                perPage: 10,
                audio: null,
                episode: null
            }
        });
    };

    if (!selectedAudio) return null;

    return (
        <Sidebar
            size="xl"
            width={900}
            open={open}
            title="Historial de Usuarios"
            headerClassName="mb-1"
            contentClassName="pt-0"
            toggleSidebar={toggleSidebar}
            onClosed={handleSidebarClosed}
        >
            <div className="mb-2">
                <Label className="form-label fw-bold">Episodio</Label>
                <div>
                    <span>{selectedAudio.episode}</span>
                </div>
            </div>

            <div className="mb-2">
                <Label className="form-label fw-bold">Total de Reproducciones</Label>
                <div>
                    <span className="badge bg-primary">{selectedAudio.total}</span>
                </div>
            </div>

            <div className="mb-2">
                <Label className="form-label fw-bold">Usuarios que han escuchado</Label>
                <CustomTable
                    loading={loading}
                    store={data?.findUsersAudioHistoryPaginate?.docs || []}
                    data={{ ...data?.findUsersAudioHistoryPaginate, docs: undefined }}
                    refetch={refetch}
                    variables={variables}
                    columns={userColumns}
                    hideHeader={true}
                />
            </div>
        </Sidebar>
    );
};

export default AudioHistorySidebar;
